import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './Landing';
import Login from './Login';
import Dashboard from './Dashboard';
import ExerciseLibrary from './ExerciseLibrary';
import FitnessTest from './FitnessTest';
import { DashboardProfile } from './components/DashboardProfile';
import { DiscoverUsers } from './components/DiscoverUsers';
import { UserDetail } from './components/UserDetail';
import { OnboardingFlow } from './onboarding/OnboardingFlow';
import { RivalryProvider } from './contexts/RivalryContext';
import { RivalriesPage } from './pages/RivalriesPage';
import { CreateRivalryFlow } from './pages/CreateRivalryFlow';
import { RivalryDashboard } from './pages/RivalryDashboard';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import AuthDebug from './pages/AuthDebug';
import Waitlist from './pages/Waitlist';
import './App.css';

function App() {
  return (
    <Router>
      <RivalryProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/exercises" element={<ExerciseLibrary />} />
            <Route path="/profile" element={<DashboardProfile />} />
            <Route path="/fitness-test" element={<FitnessTest />} />
            <Route path="/discover" element={<DiscoverUsers />} />
            <Route path="/profile/:userId" element={<UserDetail />} />
            <Route path="/onboarding/*" element={<OnboardingFlow />} />

            {/* Auth Callback Routes */}
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/auth/debug" element={<AuthDebug />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Waitlist Route */}
            <Route path="/waitlist" element={<Waitlist />} />

            {/* Rivalry Routes */}
            <Route path="/rivalries" element={<RivalriesPage />} />
            <Route path="/rivalries/create" element={<CreateRivalryFlow />} />
            <Route path="/rivalries/:rivalryId" element={<RivalryDashboard />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </RivalryProvider>
    </Router>
  );
}

export default App;
